import React from 'react';
import styled from "styled-components";
import Icon from "../../../../atoms/icon";
import StarIcon from "@icons/reza-tower/star-m.svg";
import HomeIcon from "@icons/reza-tower/home.svg";
import DocumentIcon from "@icons/reza-tower/doc.svg";
import ParkingIcon from "@icons/reza-tower/parking.svg";
import SofaIcon from "@icons/reza-tower/sofa.svg";
import SaleIcon from "@icons/reza-tower/sale.svg";


const HayaatFeaturesSection = () => {

    const features = [
        {
            icon: <HomeIcon/>,
            text: 'هفت طبقه اقامتی <br/> دارای واحدهای 48 تا 125 متری'
        },

        {
            icon: <DocumentIcon/>,
            text: 'سند شش دانگ ملکی <br/> عرصه اعیان'
        },

        {
            icon: <ParkingIcon/>,
            text: 'دو طبقه پارکینگ <br/> با سیستم هوشمند'
        },

        {
            icon: <SofaIcon/>,
            text: 'فرنیش کامل <br/> شامل مبلمان، تی‌وی، تخت و...'
        },

        {
            icon: <SaleIcon/>,
            text: 'شروع قیمت هر واحد از ۱٫۵ میلیارد <className="d-none d-lg-inline-block" br/> (متری ۳۲ تا ۴۵ میلیون)'
        },
    ];

    return (
        <Container className="container">
            <h2 className="h1-bold">ویژگی‌ها و مزایا</h2>

            <div className="row mt-8">

                <div className="col-12 col-lg-4">
                    <div className="d-flex flex-lg-column align-items-center shadow rounded-8 p-24 p-lg-48 mt-16">

                        <div className="d-none d-lg-flex align-items-center">
                            <Icon className="" width={32} height="40"><StarIcon/></Icon>
                            <Icon className="" width={32} height="40"><StarIcon/></Icon>
                            <Icon className="" width={32} height="40"><StarIcon/></Icon>
                            <Icon className="" width={32} height="40"><StarIcon/></Icon>
                            <Icon className="" width={32} height="40"><StarIcon/></Icon>
                        </div>

                        <div className="d-flex d-lg-none align-items-center">
                            <Icon className="" width={40} height="40"><StarIcon/></Icon>
                        </div>

                        <p className="h3-normal text-lg-center mt-0 mt-lg-24 mr-32 mr-lg-0">
                            بزرگترین هتل آپارتمان کشور <br/> با سازه تمام بتنی
                        </p>
                    </div>
                </div>


                {
                    features.map((feature, key) =>
                        <div className="col-12 col-lg-4" key={key}>
                            <div className="d-flex flex-lg-column align-items-center shadow rounded-8 p-24 p-lg-48 mt-16">

                                <Icon className="" width={40} height={40}>
                                    {feature.icon}
                                </Icon>

                                <p className="h3-normal text-lg-center mt-0 mt-lg-24 mr-32 mr-lg-0"
                                   dangerouslySetInnerHTML={{__html: feature.text}}/>
                            </div>
                        </div>
                    )
                }
            </div>
        </Container>
    );
};

export default React.memo(HayaatFeaturesSection);

// styles

const Container = styled.div`
    .icons {
        svg {
            g, path {
                stroke: ${props => props.theme.black};
            }
        }
    }
`;